import './forbidden';
import './baseurl';


// WEBPACK FOOTER //
// ./src/app/components/intercepts/index.js